import type { FC, ReactNode } from 'react';
import { HiSortAscending, HiSortDescending } from 'react-icons/hi';
import { Box, IconButton, TableCell } from '@mui/material';

import useFollowUpActionTable from 'src/components/myFollowUp/FollowUpActionPage/components/FollowUpActionTable/FollowUpActionTableContext';

import useFollowUpTable from '../FollowUpTableContext';

import { styles } from './HeaderCell.styles';

interface HeaderTableCellProps {
  columnKey: string;
  minWidth: string;
  children?: ReactNode;
  isFollowUpActionTable?: boolean;
}

const HeaderTableCell: FC<HeaderTableCellProps> = ({
  children,
  columnKey,
  minWidth,
  isFollowUpActionTable = false,
}) => {
  const useTable = isFollowUpActionTable
    ? useFollowUpActionTable
    : useFollowUpTable;
  const { ordering, setOrdering } = useTable();

  return (
    <TableCell component="th" sx={styles.tableCell(minWidth)}>
      <Box
        component="span"
        sx={styles.wrapper}
        onClick={() =>
          setOrdering((prev) =>
            prev === `-${columnKey}` ? columnKey : `-${columnKey}`,
          )
        }
      >
        {children}
        <IconButton aria-label={`${columnKey}-sort-button`}>
          {ordering === `-${columnKey}` ? (
            <HiSortDescending size={16} color="red" />
          ) : (
            <HiSortAscending
              size={16}
              color={ordering === columnKey ? 'red' : 'inherit'}
            />
          )}
        </IconButton>
      </Box>
    </TableCell>
  );
};

export default HeaderTableCell;
